import { render, staticRenderFns } from "./formInvoiceHeader.vue?vue&type=template&id=97e2049c&scoped=true"
import script from "./formInvoiceHeader.vue?vue&type=script&lang=js"
export * from "./formInvoiceHeader.vue?vue&type=script&lang=js"
import style0 from "./formInvoiceHeader.vue?vue&type=style&index=0&id=97e2049c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e2049c",
  null
  
)

export default component.exports